<template>
  <div
    class="p-field p-d-flex"
    :class="{ 'p-flex-column': !directionRow, 'direction-row': directionRow }"
  >
    <label
      v-if="label"
      :class="{
        'p-error': !!errorMessage,
        'p-focus': focus_status && !errorMessage,
      }"
      :for="id"
    >
      {{ label }}
    </label>
    <div class="p-d-flex p-flex-column span-container">
      <span
        :class="{
          'p-input-icon-left': iconClass != undefined && !iconRight,
          'p-input-icon-right': iconClass != undefined && iconRight,
        }"
      >
        <i v-if="iconClass != undefined" :class="iconClass" />

        <Textarea
          :disabled="disabled"
          :id="id"
          :autoResize="autoResize"
          :name="name"
          :placeholder="placeholder"
          :modelValue="text.value"
          :rows="rows"
          :cols="cols"
          v-model="text.value"
          @input="$emit('update:modelValue', $event.target.value)"
          @focus="focus_status = true"
          @blur="focus_status = false"
          :style="cstyle"
        />
      </span>
      <small v-if="displayError && !!errorMessage" :class="{ 'p-error': true }">
        {{ errorMessage }}</small
      >
    </div>
  </div>
</template>
<script>
// import Textarea from "primevue/textarea/sfc";
import { defineAsyncComponent } from 'vue'
const Textarea = defineAsyncComponent(() =>
  import('primevue/textarea')
)

import TBaseInput from "./TBaseInput";
import { watch } from "vue";

import { useField } from "vee-validate/dist/vee-validate.min.js";
import { reactive, ref } from "@vue/reactivity";

export default {
  extends: TBaseInput,
  components: { Textarea },
  setup(props, { emit }) {
    const { value, errorMessage } = useField(props.name, undefined, {
      initialValue: props.modelValue,
    });

    const text = reactive({
      value: value,
    });

    watch(
      () => props.modelValue,
      (first, second) => {
        text.value = first;
      }
    );

    let onInput = (e) => {
      emit("update:modelValue", e.target.value);
      if (typeof props.onInputText == "function") {
        props.onInputText(e.target.value);
      }
    };

    return {
      errorMessage,
      onInput,
      text,
    };
  },

  emits: ["input"],

  props: {
    cstyle: {type: String},
    displayError: { type: Boolean, default: true },
    onInputText: Function,
    cols: {
      type: Number,
      default: 0,
    },
    rows: {
      type: Number,
      default: 10,
    },
    autoResize: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../style/components/input-text/base-input.scss";
</style>
